/**
 * nalli-currency-data.js
 *
 * Verbatim port of the BUCKS Currency Converter config that was live on
 * shopnalli.myshopify.com, extracted 2026-08-01 from:
 *   bucksCC.metaConfig.selectedCurrencies  (151 entries -> display names)
 *   bucksCC.currencyFormats                (172 entries -> money_format)
 *
 * `n` = display name exactly as BUCKS showed it (showCurrencyCodesOnly: false)
 * `f` = Shopify money_format string, HTML entities intact, decoded at runtime
 *
 * Dropped vs BUCKS (obsolete, no rate source publishes them):
 *   BYR (-> BYN, 2016), LVL (-> EUR, 2014), STD (-> STN, 2018)
 *
 * Loaded before nalli-currency.js, which reads window.NALLI_CURRENCIES.
 */
window.NALLI_CURRENCIES = {
"INR":{"f":"&#8377; {{amount}}","n":"Indian Rupee (INR)"},
"USD":{"f":"${{amount}}","n":"US Dollar (USD)"},
"EUR":{"f":"&euro;{{amount_with_comma_separator}}","n":"Euro (EUR)"},
"GBP":{"f":"&pound;{{amount}}","n":"British Pound (GBP)"},
"CAD":{"f":"${{amount}}","n":"Canadian Dollar (CAD)"},
"AUD":{"f":"${{amount}}","n":"Australian Dollar (AUD)"},
"AED":{"f":"Dhs. {{amount}}","n":"United Arab Emirates Dirham (AED)"},
"SGD":{"f":"S${{amount}}","n":"Singapore Dollar (SGD)"},
"AFN":{"f":"&#65;&#102; {{amount}}","n":"Afghan Afghani (AFN)"},
"ALL":{"f":"Lek {{amount}}","n":"Albanian Lek (ALL)"},
"DZD":{"f":"DA {{amount}}","n":"Algerian Dinar (DZD)"},
"AOA":{"f":"Kz{{amount}}","n":"Angolan Kwanza (AOA)"},
"ARS":{"f":"${{amount_with_comma_separator}}","n":"Argentine Peso (ARS)"},
"AMD":{"f":"{{amount}}","n":"Armenian Dram (AMD)"},
"AWG":{"f":"Afl{{amount}}","n":"Aruban Florin (AWG)"},
"BBD":{"f":"${{amount}}","n":"Barbadian Dollar (BBD)"},
"AZN":{"f":"&#8380;{{amount}}","n":"Azerbaijani Manat (AZN)"},
"BDT":{"f":"Tk {{amount}}","n":"Bangladeshi Taka (BDT)"},
"BSD":{"f":"BS${{amount}}","n":"Bahamian Dollar (BSD)"},
"BHD":{"f":"{{amount}} BD","n":"Bahraini Dinar (BHD)"},
"BIF":{"f":"&#70;&#66;&#117; {{amount}}","n":"Burundian Franc (BIF)"},
"BYN":{"f":"Br {{amount}}","n":"Belarusian Ruble (BYN)"},
"BZD":{"f":"BZ${{amount}}","n":"Belize Dollar (BZD)"},
"BMD":{"f":"&#36; {{amount}}","n":"Bermudan Dollar (BMD)"},
"BTN":{"f":"Nu {{amount}}","n":"Bhutanese Ngultrum (BTN)"},
"BAM":{"f":"KM {{amount_with_comma_separator}}","n":"Bosnia-Herzegovina Convertible Mark (BAM)"},
"BRL":{"f":"R$ {{amount_with_comma_separator}}","n":"Brazilian Real (BRL)"},
"BOB":{"f":"Bs{{amount_with_comma_separator}}","n":"Bolivian Boliviano (BOB)"},
"BWP":{"f":"P{{amount}}","n":"Botswanan Pula (BWP)"},
"BND":{"f":"${{amount}}","n":"Brunei Dollar (BND)"},
"BGN":{"f":"{{amount}} лв","n":"Bulgarian Lev (BGN)"},
"MMK":{"f":"K{{amount}}","n":"Myanmar Kyat (MMK)"},
"KHR":{"f":"KHR{{amount}}","n":"Cambodian Riel (KHR)"},
"CVE":{"f":"&#36; {{amount}}","n":"Cape Verdean Escudo (CVE)"},
"KYD":{"f":"${{amount}}","n":"Cayman Islands Dollar (KYD)"},
"XAF":{"f":"FCFA{{amount}}","n":"Central African CFA Franc (XAF)"},
"CLP":{"f":"${{amount_no_decimals}}","n":"Chilean Peso (CLP)"},
"CNY":{"f":"&#165;{{amount}}","n":"Chinese Yuan (CNY)"},
"COP":{"f":"${{amount_with_comma_separator}}","n":"Colombian Peso (COP)"},
"KMF":{"f":"&#67;&#70; {{amount}}","n":"Comorian Franc (KMF)"},
"CDF":{"f":"&#70;&#67; {{amount}}","n":"Congolese Franc (CDF)"},
"CRC":{"f":"&#8353; {{amount_with_comma_separator}}","n":"Costa Rican Colón (CRC)"},
"CZK":{"f":"{{amount_with_comma_separator}} K&#269;","n":"Czech Koruna (CZK)"},
"DKK":{"f":"kr {{amount_with_comma_separator}}","n":"Danish Krone (DKK)"},
"DJF":{"f":"&#70;&#100;&#106; {{amount}}","n":"Djiboutian Franc (DJF)"},
"DOP":{"f":"RD$ {{amount}}","n":"Dominican Peso (DOP)"},
"XCD":{"f":"${{amount}}","n":"East Caribbean Dollar (XCD)"},
"EGP":{"f":"LE {{amount}}","n":"Egyptian Pound (EGP)"},
"ETB":{"f":"Br{{amount}}","n":"Ethiopian Birr (ETB)"},
"FKP":{"f":"&#163; {{amount}}","n":"Falkland Islands Pound (FKP)"},
"XPF":{"f":"{{amount_no_decimals_with_comma_separator}} XPF","n":"CFP Franc (XPF)"},
"FJD":{"f":"${{amount}}","n":"Fijian Dollar (FJD)"},
"GIP":{"f":"&#163; {{amount}}","n":"Gibraltar Pound (GIP)"},
"GMD":{"f":"D {{amount}}","n":"Gambian Dalasi (GMD)"},
"GHS":{"f":"GH&#8373;{{amount}}","n":"Ghanaian Cedi (GHS)"},
"GTQ":{"f":"Q{{amount}}","n":"Guatemalan Quetzal (GTQ)"},
"GYD":{"f":"G${{amount}}","n":"Guyanaese Dollar (GYD)"},
"GEL":{"f":"{{amount}} GEL","n":"Georgian Lari (GEL)"},
"GNF":{"f":"&#70;&#71; {{amount}}","n":"Guinean Franc (GNF)"},
"HTG":{"f":"&#71; {{amount}}","n":"Haitian Gourde (HTG)"},
"HNL":{"f":"L {{amount}}","n":"Honduran Lempira (HNL)"},
"HKD":{"f":"HK${{amount}}","n":"Hong Kong Dollar (HKD)"},
"HUF":{"f":"{{amount_no_decimals_with_comma_separator}}","n":"Hungarian Forint (HUF)"},
"ISK":{"f":"{{amount_no_decimals}} kr","n":"Icelandic Króna (ISK)"},
"IDR":{"f":"{{amount_with_comma_separator}} IDR","n":"Indonesian Rupiah (IDR)"},
"ILS":{"f":"&#8362;{{amount}}","n":"Israeli New Shekel (ILS)"},
"IRR":{"f":"&#65020; {{amount}}","n":"Iranian Rial (IRR)"},
"IQD":{"f":"&#1593;.&#1583; {{amount}}","n":"Iraqi Dinar (IQD)"},
"JMD":{"f":"${{amount}}","n":"Jamaican Dollar (JMD)"},
"JPY":{"f":"&#165;{{amount_no_decimals}}","n":"Japanese Yen (JPY)"},
"JEP":{"f":"&pound;{{amount}}","n":"Jersey Pound (JEP)"},
"JOD":{"f":"{{amount}} JD","n":"Jordanian Dinar (JOD)"},
"KZT":{"f":"{{amount}} KZT","n":"Kazakhstani Tenge (KZT)"},
"KES":{"f":"KSh{{amount}}","n":"Kenyan Shilling (KES)"},
"KWD":{"f":"{{amount}} KD","n":"Kuwaiti Dinar (KWD)"},
"KGS":{"f":"лв{{amount}}","n":"Kyrgystani Som (KGS)"},
"LAK":{"f":"&#8365; {{amount}}","n":"Laotian Kip (LAK)"},
"LBP":{"f":"L.L.{{amount}}","n":"Lebanese Pound (LBP)"},
"LSL":{"f":"&#76; {{amount}}","n":"Lesotho Loti (LSL)"},
"LRD":{"f":"&#36; {{amount}}","n":"Liberian Dollar (LRD)"},
"LYD":{"f":"&#1604;.&#1583; {{amount}}","n":"Libyan Dinar (LYD)"},
"MGA":{"f":"Ar {{amount}}","n":"Malagasy Ariary (MGA)"},
"MKD":{"f":"ден {{amount}}","n":"Macedonian Denar (MKD)"},
"MOP":{"f":"MOP${{amount}}","n":"Macanese Pataca (MOP)"},
"MWK":{"f":"&#77;&#75; {{amount}}","n":"Malawian Kwacha (MWK)"},
"MVR":{"f":"Rf{{amount}}","n":"Maldivian Rufiyaa (MVR)"},
"MXN":{"f":"$ {{amount}}","n":"Mexican Peso (MXN)"},
"MYR":{"f":"RM{{amount}}","n":"Malaysian Ringgit (MYR)"},
"MUR":{"f":"Rs {{amount}}","n":"Mauritian Rupee (MUR)"},
"MDL":{"f":"{{amount}} MDL","n":"Moldovan Leu (MDL)"},
"MAD":{"f":"{{amount}} dh","n":"Moroccan Dirham (MAD)"},
"MNT":{"f":"{{amount_no_decimals}} &#8366","n":"Mongolian Tugrik (MNT)"},
"MZN":{"f":"{{amount}} Mt","n":"Mozambican Metical (MZN)"},
"NAD":{"f":"N${{amount}}","n":"Namibian Dollar (NAD)"},
"NPR":{"f":"Rs{{amount}}","n":"Nepalese Rupee (NPR)"},
"ANG":{"f":"&fnof;{{amount}}","n":"Netherlands Antillean Guilder (ANG)"},
"NZD":{"f":"${{amount}}","n":"New Zealand Dollar (NZD)"},
"NIO":{"f":"C${{amount}}","n":"Nicaraguan Córdoba (NIO)"},
"NGN":{"f":"&#8358;{{amount}}","n":"Nigerian Naira (NGN)"},
"NOK":{"f":"kr {{amount_with_comma_separator}}","n":"Norwegian Krone (NOK)"},
"OMR":{"f":"{{amount}} OMR","n":"Omani Riyal (OMR)"},
"PAB":{"f":"&#66;&#47;&#46; {{amount}}","n":"Panamanian Balboa (PAB)"},
"PKR":{"f":"Rs.{{amount}}","n":"Pakistani Rupee (PKR)"},
"PGK":{"f":"K {{amount}}","n":"Papua New Guinean Kina (PGK)"},
"PYG":{"f":"Gs. {{amount_no_decimals_with_comma_separator}}","n":"Paraguayan Guarani (PYG)"},
"PEN":{"f":"S/. {{amount}}","n":"Peruvian Sol (PEN)"},
"PHP":{"f":"&#8369;{{amount}}","n":"Philippine Peso (PHP)"},
"PLN":{"f":"{{amount_with_comma_separator}} zl","n":"Polish Zloty (PLN)"},
"QAR":{"f":"QAR {{amount_with_comma_separator}}","n":"Qatari Riyal (QAR)"},
"RON":{"f":"{{amount_with_comma_separator}} lei","n":"Romanian Leu (RON)"},
"RUB":{"f":"&#8381; {{amount_with_comma_separator}}","n":"Russian Ruble (RUB)"},
"RWF":{"f":"{{amount_no_decimals}} RF","n":"Rwandan Franc (RWF)"},
"WST":{"f":"WS$ {{amount}}","n":"Samoan Tala (WST)"},
"SHP":{"f":"&#163; {{amount}}","n":"St. Helena Pound (SHP)"},
"SAR":{"f":"{{amount}} SR","n":"Saudi Riyal (SAR)"},
"RSD":{"f":"{{amount}} RSD","n":"Serbian Dinar (RSD)"},
"SCR":{"f":"Rs {{amount}}","n":"Seychellois Rupee (SCR)"},
"SLL":{"f":"&#76;&#101; {{amount}}","n":"Sierra Leonean Leone (SLL)"},
"SDG":{"f":"&#163; {{amount}}","n":"Sudanese Pound (SDG)"},
"SYP":{"f":"S&pound;{{amount}}","n":"Syrian Pound (SYP)"},
"ZAR":{"f":"R {{amount}}","n":"South African Rand (ZAR)"},
"KRW":{"f":"&#8361;{{amount_no_decimals}}","n":"South Korean Won (KRW)"},
"SBD":{"f":"&#36; {{amount}}","n":"Solomon Islands Dollar (SBD)"},
"LKR":{"f":"Rs {{amount}}","n":"Sri Lankan Rupee (LKR)"},
"SRD":{"f":"&#36; {{amount}}","n":"Surinamese Dollar (SRD)"},
"SZL":{"f":"&#76; {{amount}}","n":"Swazi Lilangeni (SZL)"},
"SEK":{"f":"kr {{amount_no_decimals}}","n":"Swedish Krona (SEK)"},
"CHF":{"f":"CHF {{amount}}","n":"Swiss Franc (CHF)"},
"TWD":{"f":"${{amount}}","n":"New Taiwan Dollar (TWD)"},
"THB":{"f":"{{amount}} &#xe3f;","n":"Thai Baht (THB)"},
"TJS":{"f":"&#84;&#74;&#83; {{amount}}","n":"Tajikistani Somoni (TJS)"},
"TZS":{"f":"{{amount}} TZS","n":"Tanzanian Shilling (TZS)"},
"TOP":{"f":"&#84;&#36; {{amount}}","n":"Tongan Paʻanga (TOP)"},
"TTD":{"f":"${{amount}}","n":"Trinidad & Tobago Dollar (TTD)"},
"TND":{"f":"{{amount}}","n":"Tunisian Dinar (TND)"},
"TRY":{"f":"{{amount}} TL","n":"Turkish Lira (TRY)"},
"TMT":{"f":"&#109; {{amount}}","n":"Turkmenistani Manat (TMT)"},
"UGX":{"f":"Ush {{amount_no_decimals}}","n":"Ugandan Shilling (UGX)"},
"UAH":{"f":"₴{{amount}}","n":"Ukrainian Hryvnia (UAH)"},
"UYU":{"f":"${{amount_with_comma_separator}}","n":"Uruguayan Peso (UYU)"},
"UZS":{"f":"&#1083;&#1074; {{amount}}","n":"Uzbekistani Som (UZS)"},
"VUV":{"f":"${{amount}}","n":"Vanuatu Vatu (VUV)"},
"VES":{"f":"Bs. {{amount_with_comma_separator}}","n":"Venezuelan Bolívar (VES)"},
"VND":{"f":"{{amount_no_decimals_with_comma_separator}}&#8363;","n":"Vietnamese Dong (VND)"},
"XOF":{"f":"CFA{{amount}}","n":"West African CFA Franc (XOF)"},
"YER":{"f":"&#65020; {{amount}}","n":"Yemeni Rial (YER)"},
"ZMW":{"f":"K{{amount_no_decimals_with_comma_separator}}","n":"Zambian Kwacha (ZMW)"}
};

/**
 * Row index of each currency in assets/nalli-flags.png — a vertical sprite of
 * 48x36 public-domain flag images, one row per currency, built from flagcdn.com
 * at build time (the storefront never calls flagcdn). Regenerate the sprite and
 * this map together if the currency list ever changes.
 */
window.NALLI_FLAG_ROWS = {"INR":0,"USD":1,"EUR":2,"GBP":3,"CAD":4,"AUD":5,"AED":6,"SGD":7,"AFN":8,"ALL":9,"DZD":10,"AOA":11,"ARS":12,"AMD":13,"AWG":14,"BBD":15,"AZN":16,"BDT":17,"BSD":18,"BHD":19,"BIF":20,"BYN":21,"BZD":22,"BMD":23,"BTN":24,"BAM":25,"BRL":26,"BOB":27,"BWP":28,"BND":29,"BGN":30,"MMK":31,"KHR":32,"CVE":33,"KYD":34,"XAF":35,"CLP":36,"CNY":37,"COP":38,"KMF":39,"CDF":40,"CRC":41,"CZK":42,"DKK":43,"DJF":44,"DOP":45,"XCD":46,"EGP":47,"ETB":48,"FKP":49,"XPF":50,"FJD":51,"GIP":52,"GMD":53,"GHS":54,"GTQ":55,"GYD":56,"GEL":57,"GNF":58,"HTG":59,"HNL":60,"HKD":61,"HUF":62,"ISK":63,"IDR":64,"ILS":65,"IRR":66,"IQD":67,"JMD":68,"JPY":69,"JEP":70,"JOD":71,"KZT":72,"KES":73,"KWD":74,"KGS":75,"LAK":76,"LBP":77,"LSL":78,"LRD":79,"LYD":80,"MGA":81,"MKD":82,"MOP":83,"MWK":84,"MVR":85,"MXN":86,"MYR":87,"MUR":88,"MDL":89,"MAD":90,"MNT":91,"MZN":92,"NAD":93,"NPR":94,"ANG":95,"NZD":96,"NIO":97,"NGN":98,"NOK":99,"OMR":100,"PAB":101,"PKR":102,"PGK":103,"PYG":104,"PEN":105,"PHP":106,"PLN":107,"QAR":108,"RON":109,"RUB":110,"RWF":111,"WST":112,"SHP":113,"SAR":114,"RSD":115,"SCR":116,"SLL":117,"SDG":118,"SYP":119,"ZAR":120,"KRW":121,"SBD":122,"LKR":123,"SRD":124,"SZL":125,"SEK":126,"CHF":127,"TWD":128,"THB":129,"TJS":130,"TZS":131,"TOP":132,"TTD":133,"TND":134,"TRY":135,"TMT":136,"UGX":137,"UAH":138,"UYU":139,"UZS":140,"VUV":141,"VES":142,"VND":143,"XOF":144,"YER":145,"ZMW":146};
